import React, { CSSProperties } from 'react';
import { colors } from '../colors';

type Props = {
  children?: any;
  onPress?: () => void;
  activeOpacity?: number;
  borderless?: boolean;
  title?: string;
  style?: CSSProperties;
};

export const Button2: React.FC<Props> = ({
  children,
  onPress,
  activeOpacity = 0.3,
  borderless = false,
  title,
  style,
}) => {
  const buttonStyle: CSSProperties = {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    ...style,
  };

  const borderlessTextStyle: CSSProperties = {
    fontSize: '20px',
    color: colors.brown_font,
  };

  if (borderless) {
    return (
      <button onClick={onPress} style={buttonStyle}>
        <span style={borderlessTextStyle}>{title}</span>
      </button>
    );
  }

  return (
    <button onClick={onPress} style={buttonStyle}>
      {children}
    </button>
  );
};
